import Container from "../../components/Container/Container";
import {Button, Card, Col, Flex, Form, Grid, Input, message, Row, Tooltip, Typography} from "antd";
import {CopyOutlined, GoogleOutlined} from "@ant-design/icons";
import GoogleAuthenticate from "../../components/GoogleAuthenticate/GoogleAuthenticate";
import {useContext, useEffect, useState} from "react";
import updatePassword from "../../api/user/updatePassword";
import useAuthHeader from "../../hooks/useAuthHeader";
import LoadingContext from "../../contexts/LoadingContext";
import useAuth from "../../hooks/useAuth";

function Security() {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;
    const [password,setPassword] = useState();
    const [newPassword,setNewPassword] = useState();
    const [reNewPassword,setReNewPassword] = useState();
    const [messageApi, contextHolder] = message.useMessage();
    const accessToken = useAuthHeader();
    const {setLoading} = useContext(LoadingContext);

    const handleUpdate = () => {
        if (!password) {
            messageApi.open({
                type: 'error',
                content: 'Vui lòng nhập mật khẩu hiện tại',
            });
            return;
        }
        if (!newPassword) {
            messageApi.open({
                type: 'error',
                content: 'Vui lòng nhập mật khẩu mới',
            });
            return;
        }
        if (!reNewPassword) {
            messageApi.open({
                type: 'error',
                content: 'Vui lòng xác nhận mật khẩu mới',
            });
            return;
        }
        if (newPassword !== reNewPassword) {
            messageApi.open({
                type: 'warning',
                content: 'Mật khẩu mới và mật khẩu xác nhận không trùng khớp vui lòng kiểm tra lại',
            });
            return;
        }
        const fetchData = async () => {
            setLoading(true);
            const response = await updatePassword(accessToken,password,newPassword);
            if (!response.success) {
                messageApi.open({
                    type: 'error',
                    content: response.message
                });
            }
            else {
                messageApi.open({
                    type: 'success',
                    content: 'Cập nhật mật khẩu thành công'
                });
            }
            setLoading(false);
        }
        fetchData();
    }

    return (
        <Container>
            {contextHolder}
            <Row gutter={[16,16]}>
                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                    <Card title={'Đổi mật khẩu'}>
                        <Form
                            layout={isMobile ? 'vertical' : 'horizontal'}
                            labelCol={isMobile ? undefined : { span: 6 }}
                        >
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={'Mật khẩu hiện tại'} name={'password'}
                                           style={{
                                               fontWeight: 600
                                           }}
                                >
                                    <Input.Password
                                        placeholder={'Nhập mật khẩu hiện tại'}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={'Mật khẩu mới'} name={'newPassword'}
                                           style={{
                                               fontWeight: 600
                                           }}
                                >
                                    <Input.Password
                                        placeholder={'Nhập mật khẩu mới'}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={'Xác nhận mật khẩu mới'} name={'reNewPassword'}
                                           style={{
                                               fontWeight: 600
                                           }}
                                >
                                    <Input.Password
                                        placeholder={'Nhập lại mật khẩu mới'}
                                        onChange={(e) => setReNewPassword(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Flex justify={'center'}>
                                    <Button type={'primary'} onClick={handleUpdate}>Xác nhận</Button>
                                </Flex>
                            </Col>
                        </Form>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                    <Card title={'Cài đặt bảo mật'}>
                        <GoogleAuthenticate/>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}

export default Security;
